import { ToolbarGroup } from '../ToolbarGroup'
import { DeleteTokenToolbarButton } from './DeleteTokenToolbarButton'

export function TokenToolbarGroup() {
    return (
        <ToolbarGroup>
            <DeleteTokenToolbarButton />
        </ToolbarGroup>
    )
}
